<template lang="pug">
  .contact-colorist
    p.contact-title.text-center.bold.color-slate.upper.xs-f-xsmall.lg-f-medium.max-at-tweak Contact a Professional Colorist
    p.color-slate.xs-f-small.lg-f-medium.max-at-tweak(v-html="message")
    SupportCtas(:hideCtas='["email"]' :track-event-params="trackEventParams")
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import SupportCtas from '../SupportCtas';

  export default {
    name: "ContactColorist",

    props: {
      message: {
        type: String,
        required: true
      },

      trackEventParams: {
        type: Object,
        required: false,
        default: null
      }
    }, 

    components: {
      SupportCtas
    }
}
</script>

<style scoped lang="stylus">
  .contact-colorist
    padding-top 1em
    background-color bg-color-info
    display inline-block
    width 100%

    p
      padding .25em 5em

    .support-ctas
        padding 1.2em

  @media mq-mobile
    .contact-colorist
      p
        padding .5em 1em

</style>